import { Icons } from '@/assets/icons/icons';
import { IconButton } from '@/components/ui/IconButton';
import { XStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';

import { MotionRow } from './motion-row';
import { fieldInput } from './styles';

export function KeyValueRow({
  keyValue,
  value,
  onKeyChange,
  onValueChange,
  onRemove,
  keyPlaceholder,
  valuePlaceholder,
  keyWidthClass,
  secret,
  warn,
  danger,
}: {
  keyValue: string;
  value: string;
  onKeyChange: (v: string) => void;
  onValueChange: (v: string) => void;
  onRemove: () => void;
  keyPlaceholder: string;
  valuePlaceholder: string;
  keyWidthClass: string;
  secret?: { reveal: boolean; onToggle: () => void };
  warn?: boolean;
  danger?: boolean;
}) {
  return (
    <MotionRow>
      <XStack className="items-center gap-1.5">
        <input
          value={keyValue}
          onChange={(e) => onKeyChange(e.target.value)}
          spellCheck={false}
          placeholder={keyPlaceholder}
          className={cn(
            fieldInput.row,
            keyWidthClass,
            warn && 'border-warning-8',
            danger && 'border-danger-8'
          )}
        />
        {secret ? (
          <div className="relative flex flex-1 items-center">
            <input
              value={value}
              onChange={(e) => onValueChange(e.target.value)}
              type={secret.reveal ? 'text' : 'password'}
              spellCheck={false}
              placeholder={valuePlaceholder}
              className={cn(fieldInput.row, 'w-full pr-8')}
            />
            <button
              type="button"
              title="Show / hide"
              onClick={secret.onToggle}
              className="absolute right-1 flex size-6 items-center justify-center rounded-sm text-foreground-muted hover:text-foreground"
            >
              {secret.reveal ? (
                <Icons.eyeOff className="size-3.5" />
              ) : (
                <Icons.eye className="size-3.5" />
              )}
            </button>
          </div>
        ) : (
          <input
            value={value}
            onChange={(e) => onValueChange(e.target.value)}
            spellCheck={false}
            placeholder={valuePlaceholder}
            className={cn(fieldInput.row, 'flex-1')}
          />
        )}
        <IconButton
          icon={Icons.trash}
          variant="outline"
          size="md"
          tooltip="Remove"
          onClick={onRemove}
        />
      </XStack>
    </MotionRow>
  );
}
